import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
};

const ColorSwatch = ({
  color,
  shape,
  size,
  layout,
  align,
  showHex,
  showCopyBtn,
}) => {
  const intl = useIntl();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(color.hex);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const alignValue = align || 'left';
  const alignClass = layout === 'column'
    ? ` puck-colors-swatch--align-${alignValue}`
    : ` puck-colors-swatch--row-align-${alignValue}`;

  return (
    <div className={`puck-colors-swatch puck-colors-swatch--${layout}${alignClass}`}>
      <div
        className={`puck-colors-shape puck-colors-shape--${shape} puck-colors-shape--${size || 'md'}`}
        style={{ background: color.hex }}
      />
      <div className="puck-colors-swatch-info">
        {color.title && (
          <div className="puck-colors-swatch-title">
            {color.title}
          </div>
        )}
        {color.subtitle && (
          <div className="puck-colors-swatch-subtitle">
            {color.subtitle}
          </div>
        )}
        {showHex && (
          <div className="puck-colors-swatch-hex">
            {color.hex}
          </div>
        )}
        {showCopyBtn && (
          <Button
            type="button"
            color="link"
            size="sm"
            className="puck-colors-copy-btn"
            onClick={handleCopy}
          >
            <i className={`fal fa-${copied ? 'check' : 'copy'} mr-1 fa-fw`} />
            {copied
              ? intl.formatMessage({ defaultMessage: 'Copied!' })
              : intl.formatMessage({ defaultMessage: 'Copy hex' })}
          </Button>
        )}
      </div>
    </div>
  );
};

ColorSwatch.propTypes = {
  color: PropTypes.shape({
    hex: PropTypes.string.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
  shape: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired,
  align: PropTypes.string.isRequired,
  showHex: PropTypes.bool.isRequired,
  showCopyBtn: PropTypes.bool.isRequired,
};

export default ColorSwatch;
